module.exports = __webpack_public_path__ + "static/media/darlene_kabigting.386fcd75.png";